let clientHints: {
  platformVersion: string;
};

export const initializeClientHints = async () => {
  if (!navigator.userAgentData) {
    return;
  }

  const highEntropyValues = await navigator.userAgentData.getHighEntropyValues(["platformVersion"]);

  clientHints = {
    platformVersion: highEntropyValues.platformVersion,
  };
};

export const getClientHints = () => {
  if (!navigator.userAgentData) {
    return {};
  }

  if (!clientHints) {
    throw new Error("Client hints not initialized. Please call initializeClientHints() first.");
  }

  return {
    platformVersion: clientHints.platformVersion,
  };
};
